module.exports = __webpack_public_path__ + "img/banner_kitten.8dc9fdb2.jpg";